
import { useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { EventData } from '../types';

export const useEventData = (eventId: string) => {
  const {
    data,
    isLoading,
    error
  } = useQuery({
    queryKey: ['rsvp-event-data', eventId],
    queryFn: async (): Promise<EventData> => {
      const { data, error } = await supabase
        .from('events')
        .select(`
          event_id,
          name,
          description,
          preferred_dates,
          preferred_time_of_day,
          image_url,
          event_deadline,
          host:users!events_host_user_id_fkey (
            full_name
          ),
          event_images (
            image_id,
            image_url,
            is_primary,
            display_order
          )
        `)
        .eq('event_id', eventId)
        .single();

      if (error) throw error;

      return {
        id: data.event_id,
        name: data.name,
        description: data.description,
        hostName: data.host?.full_name,
        preferredDates: data.preferred_dates || [],
        preferredTimes: data.preferred_time_of_day || [],
        imageUrl: data.image_url,
        event_deadline: data.event_deadline,
        eventImages: data.event_images || []
      };
    },
  });

  return {
    eventData: data,
    isLoading,
    error
  };
};
